// extracted by mini-css-extract-plugin
export default {"container":"statistics_container__YBqEN","gridWrapper":"statistics_gridWrapper__xeR+z"};